import React, { useEffect, useState } from "react";
import SectionHeading from "../SectionHeading";
import { Link } from "react-router-dom";
import { PublicApi } from "api/api";
import { useTranslation } from "react-i18next"; 

const publicApi = new PublicApi();

const countryKey = ['bosnia','kosovo','montenegro','macedonia','serbia']


function AreasMetrics({country,id}) {

  const [areaList,setAreaList] = useState([]);
  const { t } = useTranslation();

  // convert country name like "Serbia" → translation key "country.serbia"
  const countryKey = `country:${country?.toLowerCase().replace(/\s+/g, "-")}`;
  const translatedCountry = t(countryKey, country); // fallback to original if not found

  const getAreaByCountry = async () => {
    const response = await publicApi.apiPublicGetAllAreaByCountry({countryId:id});
    setAreaList(response?.data?.map(area => {
      return {title:area?.name,imageSrc:area?.img,id:area?.id,link:`/area/${country}/${area?.name}`}
    }))
  }


  useEffect(() => {
    getAreaByCountry()
  },[]);



  const metricsData = [
    {
      imageSrc: "/images/webp/areas-metrics1.webp",
      title: "Education",
      link: `/area/${country}/Education`,
    },
    {
      imageSrc: "/images/webp/areas-metrics2.webp",
      title: "Housing",
      link: `/area/${country}/Housing`,
    },
    {
      imageSrc: "/images/webp/areas-metrics3.webp",
      title: "Health",
      link: `/area/${country}/Health`,
    },
    {
      imageSrc: "/images/webp/areas-metrics4.webp",
      title: "Social service",
      link: `/area/${country}/Social service`,
    },
    {
      imageSrc: "/images/webp/areas-metrics5.webp",
      title: "Employment",
      link: `/area/${country}/Employment`,
    },
  ];

  return areaList.length > 0 ?(
    <section>
      <SectionHeading title={`${t("country:area-metrics:title","Areas Metrics of")} ${translatedCountry}`} />
      <div className="row justify-content-center g-4">
        {areaList.map((metric, index) => {

      const metricImg = window.location.hostname === 'localhost' && metric.imageSrc !== undefined ? `https://localhost:9111/priorityarea/${metric.imageSrc.split("/")[metric.imageSrc?.split("/")?.length - 1]}` : metric.imageSrc;

        return  <div className="col-lg-4 col-sm-6" key={index}>
            <Link to={metric.link} state={{img:metricImg || '',countryId:id,areaId:metric?.id}}>
              <div className="areas-metrics-card">
                <div className="areas-metrics-image">
                  <img
                    src={metricImg || '/images/webp/home-banner.webp'}
                    className="img-fluid"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop
                      e.target.src = '/images/webp/home-banner.webp'; // Fallback image
                    }}
                    alt={metric?.title}
                  />
                </div>
                <h5>{metric.title}</h5>
              </div>
            </Link>
          </div>
})}
      </div>
    </section>
  ) : <></>;
}

export default AreasMetrics;
